import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  optionsData: [],
  message: null,
};

export const retrieveSalesChannels = createAsyncThunk(
  "retrieveSalesChannels",
  async (storeHash) => {
    try {
      const response = await fetch(`/api/getSalesChannels/${storeHash}`, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error("Failed to fetch attributes");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const retrieveSalesChannel = createSlice({
  name: "retrieveSalesChannel",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(retrieveSalesChannels.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(retrieveSalesChannels.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.optionsData = action.payload?.data?.publications?.nodes;  // Clear the existing data

      })
      .addCase(retrieveSalesChannels.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default retrieveSalesChannel.reducer;
